import {useMemo} from 'react';
import {useSelector} from 'react-redux';
import {ReducerState} from 'rootReducer';
import {DropdownVariant} from '../shared/QuoteFormDropdownV2';
import {QuoteFormDropdownOption} from 'Quoting/models/DTOs/QuoteForm';

export const useDropdownOptions = <T extends DropdownVariant>(variant: T, searchKey: string, coverageName?: string) => {
  const lookup = useSelector((state: ReducerState) => {
    if (variant === 'Lookup') return state.quoteForm.lookups;
    if (coverageName) return state.quoteForm.attributeValuesByCoverage;
    return state.quoteForm.attributeValues;
  });

  const options = useMemo<QuoteFormDropdownOption[]>(() => {
    const searchResult = coverageName ? (lookup as any).get(coverageName)?.get(searchKey) : lookup?.get(searchKey);

    if (!Array.isArray(searchResult)) {
      return [];
    }

    return searchResult;
  }, [lookup, searchKey, variant, coverageName]);

  return options ?? [];
};
